import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Stack,
  Button,
  Form,
  Container,
  Row,
  Col,
  Card,
} from "react-bootstrap";
import Motivo from "./Motivo";
import ComentarioEditable from "./ComentarioEditable";
import Flag from "./Flag";
import BotonDescargarFicha from "./BotonDescargarFicha";
import { formatRut } from "../../validations/format";

const styles = {
  iconButton: {
    background: "none",
    border: "none",
    color: "var(--color-text-muted)",
    cursor: "pointer",
    padding: 0,
    marginLeft: "0.5rem",
  },
};

function TarjetaHistorial({ atencion, handleEditComentario, onChangeFlag }) {
  const navigate = useNavigate();

  const handleVerFicha = () => {
    navigate(`/historial/${atencion.user.idS}`);
  };
  const handleChangeFlag = (nuevoValor) => {
    onChangeFlag(atencion.user.idS, nuevoValor);
  };

  return (
    <Card key={atencion.id} className="px-3 py-2" style={styles.tarjeta}>
      <Row>
        <Col xs={12} md={4} className="d-flex flex-column">
          {/* FRANJA SUPERIOR */}
          <Stack direction="horizontal" gap={1} className="mb-1">
            <div className="mt-1 align-self-start">
              <Flag
                key={atencion.user.flag}
                idSolicitante={atencion.user.idS}
                initialFlag={atencion.user.flag}
                onChange={handleChangeFlag}
              />
            </div>

            <Stack>
              <strong>{atencion.user?.nombre}</strong>
              {atencion.user.pasaporte
                ? atencion.user.rut
                : formatRut(atencion.user.rut)}
            </Stack>
          </Stack>

          {/* FRANJA INFERIOR (BOTONES) */}
          <Stack
            direction="horizontal"
            gap={3}
            className="mt-auto align-items-center justify-content-end"
          >
            <Button
              className="btn-primary-blue"
              size="sm"
              onClick={handleVerFicha}
            >
              Ver ficha
            </Button>

            <BotonDescargarFicha
              idS={atencion.user.idS}
              size={25}
              color="muted"
              placement="bottom"
            />
          </Stack>
        </Col>

        <Col xs={8} className="d-none d-md-block">
          <Stack direction="vertical" gap={2}>
            <div className="me-auto">
              <Motivo motivo={atencion.tipo?.nombre} />
            </div>

            <ComentarioEditable
              atencion={atencion}
              onSave={handleEditComentario}
            />
          </Stack>{" "}
        </Col>
      </Row>
    </Card>
  );
}

export default TarjetaHistorial;
